// extracted by mini-css-extract-plugin
export default {"tableText":"styles_tableText__KKsl3","tooltipDisplayComponent":"styles_tooltipDisplayComponent__tI0XP"};